export default function(ngModule) {
    ngModule.factory('Event', function(BaseClass, $state, $http, $q, $translate, $timeout, $analytics, Locales, Currencies, RelationAPI, ErrorRejector, EventDate, Ticket, Product, ScannerInstance, Shop, ScannerType, EventLocation) {

        /**
         * Constructor function
         *
         * @constructor
         * @param {Object} attributes Initial attributes for the model
         */
        function Event(attributes) {
            _.assign(this, _.omit(attributes, 'location'));

            if (attributes && attributes.location) {
                this.location = EventLocation.new(attributes.location);
            }

            if (attributes && attributes.event_dates) {
                this.event_dates = _.map(attributes.event_dates, EventDate.new);
            }
        }

        Event.modelName = 'Event';

        BaseClass.apply(Event);
        Event.configureApi('/event/:guid', {
            queryAdmin: '/event/:status/:company',
            reinstate: '/event/:guid/reinstate'
        });
        Event.prototype.toString = function() {
            return this.name;
        };

        Event.validates({
            name: {
                required: true
            },
            website: {
                regex: {
                    regex: /^https?:\/\/(?:[\w\d-]+\.)+\w{2,}/i,
                    message: 'geen geldige url'
                }
            },
            type: {
                required: true,
                inclusion: {
                    in: ['once', 'repeating']
                }
            },
            locale: {
                required: true,
                inclusion: {
                    in: _.map(Locales, 'code')
                }
            },
            currency: {
                required: true,
                inclusion: {
                    in: _.map(Currencies, 'code')
                }
            }
        });

        Event.prototype.$crudCreateOrSaveChild = function(crud, modelName) {
            const event = this;
            const child = crud.model;
            const pk = child[child.constructor.primaryKey];
            const isNew = _.isUndefined(pk);

            if (child.$invalid) {
                return ErrorRejector.handle(modelName + ' invalid');
            }

            if (!isNew || typeof event['$create' + modelName] !== 'function') {
                return crud.save();
            }

            crud.busy = true;

            return crud.fire('beforeSave', child)
                .then(() => event['$create' + modelName](child))
                .then(response => {
                    crud.models.push(_.assign(child, response));

                    return crud.fire('afterSave', null, child, true);
                })
                .catch(error => crud.fire('afterSave', error, child, true).then(() => $q.reject(error)))
                .then(() => crud.list())
                .catch(error => {
                    crud.busy = false;
                    return crud.handleError(error);
                });
        };

        // ----------------------------------------
        // -------------- Event Dates -------------
        // ----------------------------------------

        Event.hasMany(
            'EventDate',         // Modelname
            'event_dates',       // propertyName
            'event_id',          // foreign key
            '/event/:guid/dates/products',// URL
            null,                // fnSuffix
            function(dates) {    // Success Function
                return _.filter(dates, d => d.name !== 'Proxy date');
            }
        );

        // ----------------------------------------
        // --------------- Tickets ----------------
        // ----------------------------------------

        Event.belongsToMany('Ticket', 'tickets', '/event/:guid/ticket', [
            {type: 'create'},
            {
                type: 'query',
                fn: function(modelName, url, instance, cacheOnly = false, withChild = false) {
                    if (cacheOnly) {
                        return $q.resolve(instance.belongsToMany.restore(modelName));
                    }

                    if (_.isString(withChild) && _.size(withChild)) {
                        url += '/' + withChild;
                    }

                    return $http.get(url).then(response => {
                        instance.broadcastAPIMessage(response);
                        var models = _.map(response.data, m => {
                            m = Ticket.new(m);
                            instance.belongsToMany.cache(modelName, m);
                            return m;
                        });
                        return $q.resolve(models);
                    }, error => {
                        instance.broadcastAPIMessage(error);
                        return $q.reject(error);
                    });
                }
            }
        ]);

        /**
         * Query the event for Tickets WITH nested shops
         *
         * @returns {Promise<Array>} Resolves with an array of scanners
         */
        Event.prototype.$queryTicketsWithShops = function() {
            return $http.get(`/event/${this.guid}/ticket/shops`).then(response => {
                this.broadcastAPIMessage(response);

                return $q.resolve(_.map(response.data, ticketData => {
                    let ticket = Ticket.new(ticketData);

                    ticket.shops = _.map(ticketData.shops, shopData => Shop.new(shopData));

                    return ticket;
                }));
            }, error => {
                this.broadcastAPIMessage(error);

                return $q.reject(error);
            });
        };

        // Event.prototype.$createSimpleTicket = function(simpleTicket) {
        //     const event = this;
        //
        //     return event.$createTicket(simpleTicket.ticket)
        //         .then(ticket => _.assign(simpleTicket.ticket, ticket))
        //         .catch(error => {
        //             let errors = _.get(error, 'data.error_description', {});
        //
        //             if (_.isObject(errors)) {
        //                 _.forEach(errors, (messages, field) => {
        //                     _.forEach(messages, message => simpleTicket.ticket.$errors.add(field, message));
        //                 });
        //             }
        //
        //             return $q.reject(error);
        //         })
        //         .then(ticket => {
        //             simpleTicket.product.description = ticket.guid;
        //             simpleTicket.product.name = 'Product for ' + ticket.name;
        //
        //             return event.$createProduct(simpleTicket.product);
        //         })
        //         .then(product => _.assign(simpleTicket.product, product))
        //         .catch(error => {
        //             let errors = _.get(error, 'data.error_description', {});
        //
        //             if (_.isObject(errors)) {
        //                 _.forEach(errors, (messages, field) => {
        //                     _.forEach(messages, message => simpleTicket.product.$errors.add(field, message));
        //                 });
        //             }
        //
        //             return $q.reject(error);
        //         })
        //         .then(product => simpleTicket.ticket.$attachProduct(product))
        //         .then(() => simpleTicket.$savedState = _.cloneDeep(simpleTicket))
        //         .then(() => simpleTicket);
        // };

        // ----------------------------------------
        // --------------- Products ---------------
        // ----------------------------------------

        Event.belongsToMany('Product', 'products', '/event/:guid/product', [
            {
                type: 'query',
                fn: function(modelName, url, instance, cacheOnly = false, withChild = false) {
                    if (cacheOnly) {
                        return $q.resolve(instance.belongsToMany.restore(modelName));
                    }

                    if (_.isString(withChild) && _.size(withChild)) {
                        url += '/' + withChild;
                    }

                    return $http.get(url).then(response => {
                        instance.broadcastAPIMessage(response);
                        var models = _.map(response.data, m => {
                            m = Product.new(m);
                            instance.belongsToMany.cache(modelName, m);
                            return m;
                        });
                        return $q.resolve(models);
                    }, error => {
                        instance.broadcastAPIMessage(error);
                        return $q.reject(error);
                    });
                }
            },
            {type: 'create'}
        ]);

        // Event.prototype.$queryAccessProduct = function() {
        //     return this.$queryEventDate()
        //         .then(dates => $q.all(_.map(dates, date => AccessProduct.initFromDate(date).catch(() => null))))
        //         .then(_.filter);
        // };

        // /**
        //  * Create an access product for this event
        //  *
        //  * @param {AccessProduct} accessProduct The Access Product to create
        //  * @returns {Promise<AccessProduct>} Resolves with an access products
        //  */
        // Event.prototype.$createAccessProduct = function(accessProduct) {
        //     const event = this;
        //
        //     return accessProduct.eventDate.$save()
        //         .then(eventDate => {
        //             _.assign(accessProduct.eventDate, eventDate);
        //
        //             accessProduct.product.description = accessProduct.eventDate.guid;
        //
        //             return event.$createProduct(accessProduct.product);
        //         }).then(product => {
        //             _.assign(accessProduct.product, product);
        //
        //             $analytics.eventTrack('created-event-date', {
        //                 name: accessProduct.eventDate.name,
        //                 start_date: parseInt(moment(accessProduct.eventDate.start).format('X'), 10),
        //                 end_date: parseInt(moment(accessProduct.eventDate.end).format('X'), 10),
        //                 label: accessProduct.product.name,
        //                 value: [accessProduct.eventDate.start, accessProduct.eventDate.end].join(' - ')
        //             });
        //
        //             return accessProduct.product.$attachEventDate(accessProduct.eventDate).then(() => accessProduct);
        //         });
        // };

        /**
         * Query the API for all products of this event and reject all products with event dates.
         *
         * @returns {Promise<Array>} Resolves with an array of products
         */
        Event.prototype.$queryAddonProduct = function() {
            return this.$queryProduct(false, 'dates').then(products => _.reject(products, product => _.size(_.get(product.$savedState, 'event_dates', [])) > 0));
        };

        // ----------------------------------------
        // ------------- Scanner types ------------
        // ----------------------------------------

        Event.belongsToMany('ScannerType', 'scannertypes', '/event/:guid/scanner', [
            {
                type: 'query',
                fn: function(modelName, url, instance, cacheOnly = false, withChild = false) {
                    if (cacheOnly) {
                        return $q.resolve(instance.belongsToMany.restore(modelName));
                    }

                    if (_.isString(withChild) && _.size(withChild)) {
                        url += '/' + withChild;
                    }

                    return $http.get(url).then(response => {
                        instance.broadcastAPIMessage(response);
                        var models = _.map(response.data, m => {
                            m = ScannerType.new(m);
                            instance.belongsToMany.cache(modelName, m);
                            return m;
                        });
                        return $q.resolve(models);
                    }, error => {
                        instance.broadcastAPIMessage(error);
                        return $q.reject(error);
                    });
                }
            },
            {type: 'create'},
            {type: 'queryOrCreate'}
        ]);

        // ----------------------------------------
        // ---------------- Shops -----------------
        // ----------------------------------------

        Event.belongsToMany('Shop', 'shops', '/event/:guid/shops', [
            {type: 'query'},
            {type: 'queryOrCreate'},
            {
                type: 'create',
                fn: function(modelName, url, instance, child, pivot) {
                    return $http.post(url, child)
                        .then(response => {
                            instance.broadcastAPIMessage(response);
                            child = Shop.new(response.data);
                            instance.belongsToMany.cache(modelName, child, pivot);
                            child.belongsToMany.cache(instance.constructor.modelName, instance, pivot);
                            return $q.resolve(child);
                        })
                        .then(shop => {
                            RelationAPI.create('EventShop', instance.guid, shop.guid);

                            return shop;
                        })
                        .catch(error => {
                            instance.broadcastAPIMessage(error);
                            return $q.reject(error);
                        });
                }
            }
        ]);

        // ----------------------------------------
        // --------------- Location ---------------
        // ----------------------------------------

        /**
         * Get the location for the Event
         *
         * @returns {Promise<EventLocation|Object>} Resolves with the event's location
         */
        Event.prototype.$getLocation = function() {
            if(!this.guid) {
                return ErrorRejector.handle('Cannot move new event to a location');
            }

            const instance = this;
            const url = `/event/${this.guid}/location`;

            return $http.get(url)
                .then(response => {
                    this.broadcastAPIMessage(response);

                    const result = response.data;

                    if (_.isArray(result)) {
                        return ErrorRejector.handle('Was expecting a single object, received array instead');
                    }

                    const location = EventLocation.new(result);

                    this.location = location;

                    return location;
                })
                .catch(error => {
                    this.broadcastAPIMessage(error);

                    return $q.reject(error);
                });
        };

        /**
         * Move the event to another location
         *
         * @param {EventLocation} location The new event location
         * @returns {Promise<EventLocation|Object>} Resolves with the new location
         */
        Event.prototype.$moveLocation = function(location) {
            if(!this.guid) {
                return ErrorRejector.handle('Cannot move new event to a location');
            }

            if (!location || !location.guid) {
                return ErrorRejector.handle('No existing location provided');
            }

            const instance = this;
            const data = _.defaults({}, location);
            const url = `/event/${this.guid}/location/${location.guid}`;

            return $http.post(url, data)
                .then(response => {
                    this.broadcastAPIMessage(response);

                    instance.location_id = location.guid;
                    instance.location = location;

                    instance.$savedState = _.cloneDeep(instance);
                    instance.constructor.cache(instance);

                    return location;
                })
                .catch(error => {
                    console.error('Failed to move event to location', error, location);

                    this.broadcastAPIMessage(error);

                    return $q.reject(error);
                });
        };

        // ----------------------------------------
        // ---------------- Admin -----------------
        // ----------------------------------------

        /**
         * Search for an event (Admin feature)
         *
         * @param {String} query A search query
         * @return {Promise<Event[]>} Promise that resolves with an array of events
         */
        Event.search = function(query) {
            if (!_.isString(query) || _.isEmpty(query)) {
                return $q.reject('invalid query');
            }

            return $http.post('/statistics/events/search', {search: query})
                .then(response => {
                    let events = response.data;

                    _.forEach(events, event => event.start = _.get(_.minBy(event.event_dates, d => moment(d.start).format('x')), 'start', 'no date'));

                    let upcoming = [];
                    let past = [];
                    let other = [];

                    _.forEach(events, function(event) {
                        if (event.start === 'no date') {
                            other.push(event);
                        } else if (moment().diff(event.start, 'minutes') < 0) {
                            upcoming.push(event);
                        } else if (moment().diff(event.start, 'minutes') >= 0) {
                            past.push(event);
                        }
                    });

                    upcoming = _.orderBy(upcoming, ['start'], ['asc']);
                    past = _.orderBy(past, ['start'], ['desc']);

                    let upcomingHeader = {name: '-------------- Upcoming --------------', start: '', company: {name: ''}};
                    let pastHeader = {name: '-------------- Past --------------', start: '', company: {name: ''}};
                    let otherHeader = {name: '-------------- Other --------------', start: '', company: {name: ''}};

                    return [upcomingHeader].concat(upcoming, [pastHeader], past, [otherHeader], other);
                });
        };

        return Event;
    });
}
